export const PageId = {
    MemberPage: 'member_page',
    SettingsPage: 'member_settings_page',
    About: 'about',
    MyAccount: 'member_info',
    FollowingFollowers: 'following_followers',
    FollowingFollowersLightbox: 'following_followers_lightbox',
    MyRewards: 'My Rewards',
    ForumPosts: 'member-posts-page',
    ForumComments: 'member-comments-page',
    Events: 'events_members_page',
    BlogComments: 'member-comments-page',
    BlogLikes: 'member-likes-page',
    BlogPosts: 'member-posts-page',
    BlogDrafts: 'member-drafts-page',
    MyPosts: 'My Posts',
    MyChallenges: 'My Challenges',
    MyPrograms: 'My Programs',
    MySubscriptions: 'My Subscriptions',
    MyBookings: 'bookings_member_area',
    MyBookingsPage: 'My Bookings',
    Notifications: 'notifications_app',
    NotificationsPage: 'Notifications',
    MyAddresses: 'my_addresses',
    MyOrders: 'order_history',
    MyWallet: 'my_wallet',
    Settings: 'settings',
    SharedGallery: 'Gallery',
    FileShare: 'wix_file_share_members_page',
    MyWishlist: 'wishlist',
    Groups: 'My Groups',
    TestPublic: 'test-vertical-public-widget',
    TestPrivate: 'test-vertical-private-widget',
    ProfilePageBob: 'test-profile-page-bob', // used for tests only
};
//# sourceMappingURL=page.js.map